export default (equipmentTypeCategoryId) => ({
    type: "VESSEL_EQUIPMENT_DETAILS_EQUIPMENT_CATEGORY_ID_UPDATED",
    data: equipmentTypeCategoryId
});